import { EyeIcon } from '@heroicons/react/outline'
import { analytics } from 'analytics'
import { Link, useNavigate } from 'react-router-dom'

import { ManagementOrganizationMembership } from 'types/userTypes'

import { VIEW_ONLY_ACCOUNT_SELECTED } from 'constants/track.constants'
import { old_COLOR } from 'styles/constants/old_color'
import { old_SPACE } from 'styles/constants/old_space'

import FlexBox from '../FlexBox/FlexBox'
import NavigationDropdownMenuItem from './NavigationDropdownMenuItem'

type Props = {
  managementOrganizationMemberships: ManagementOrganizationMembership[]
  currentOrganization?: string
}

export default function MembershipsDropdownSection({
  managementOrganizationMemberships,
  currentOrganization,
}: Props) {
  const navigate = useNavigate()

  const membershipsMenuItems = [
    {
      path: '/connected-accounts',
      icon: 'link',
      name: 'Connected Accounts',
    },
    {
      path: '/investment-templates',
      icon: 'pencil',
      name: 'Investment Templates',
    },
  ]

  return (
    <FlexBox
      borderTop={`1px solid ${old_COLOR.coolGray300}`}
      marginTop={old_SPACE.sp8}
      flexDirection="column"
      color={old_COLOR.coolGray500}
      paddingY={old_SPACE.sp8}
      fontWeight={500}
      gap={old_SPACE.sp8}
    >
      <FlexBox
        marginLeft={old_SPACE.sp8}
        marginTop={old_SPACE.sp8}
        gap={old_SPACE.sp4}
        alignItems="center"
        style={{ cursor: 'default' }}
      >
        <EyeIcon width={old_SPACE.sp14} height={old_SPACE.sp14} />
        <span>Accounts you can view:</span>
      </FlexBox>
      {managementOrganizationMemberships.map(
        (managementOrganizationMembership) => {
          const isSelected =
            currentOrganization ===
            managementOrganizationMembership.managementOrganizationId

          return (
            <FlexBox flexDirection="column">
              <Link
                to={`/organization/${managementOrganizationMembership.managementOrganizationId}`}
                key={managementOrganizationMembership.managementOrganizationId}
                onClick={() => analytics.track(VIEW_ONLY_ACCOUNT_SELECTED)}
              >
                <FlexBox
                  marginLeft={old_SPACE.sp26}
                  color={
                    isSelected ? old_COLOR.pavePurple : old_COLOR.coolGray600
                  }
                  fontWeight={isSelected ? 700 : 500}
                  style={{ cursor: 'pointer' }}
                >
                  {managementOrganizationMembership.firstName}{' '}
                  {managementOrganizationMembership.lastName}
                </FlexBox>
              </Link>

              <FlexBox
                marginTop={old_SPACE.sp8}
                marginLeft={old_SPACE.sp26}
                borderLeft={`1px solid ${old_COLOR.coolGray300}`}
                flexDirection="column"
              >
                {membershipsMenuItems.map((item) => {
                  const { path, icon, name } = item
                  return (
                    <NavigationDropdownMenuItem
                      key={name}
                      item={{
                        action: () =>
                          navigate(
                            `${path}?organization=${managementOrganizationMembership.managementOrganizationId}`
                          ),
                        icon,
                        name,
                      }}
                      size="sm"
                    />
                  )
                })}
              </FlexBox>
            </FlexBox>
          )
        }
      )}
    </FlexBox>
  )
}
